import { RadioGroup } from '@/components/inputs/radio-group';
import { BodyLocationHair } from './body-location-hair';
import { BodyLocationNails } from './body-location-nails';
import { BodyLocationSkin } from './body-location-skin';
import { Question } from '@/api/api.schemas';
import styles from './body-location.module.css';

interface BodyLocationProps {
  name: string;
  question: Question;
}

export function BodyLocation({ name, question }: BodyLocationProps) {
  return (
    <RadioGroup
      name={name}
      variant="selectorCard"
      className={styles.radioGroup}
      options={[
        {
          value: 'Skin',
          label: 'Skin',
          icon: <BodyLocationSkin className={styles.icon} pathClassName={styles.path} />,
        },
        {
          value: 'Hair',
          label: 'Hair',
          icon: <BodyLocationHair className={styles.icon} pathClassName={styles.path} />,
        },
        {
          value: 'Nails',
          label: 'Nails',
          icon: <BodyLocationNails className={styles.icon} pathClassName={styles.path} />,
        },
      ]}
      label={question.text}
      subLabel={question.subText}
    />
  );
}
